import './NavLayout.css';
import { useState } from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import MobileItemsAndPostsIcon from '../MobileItemsAndPostsIcon';
import MobileMyInfoIcon from '../MobileMyInfoIcon';
import MobileSettingsIcon from '../MobileSettingsIcon';
import Header from '../header/Header';

export default function NavLayout() {
  const [activeNavLink, setActiveNavLink] = useState('');
  const location = useLocation();

  // Check if we're on a dashboard/admin route
  const isDashboardRoute = location.pathname.includes('/admin');

  function handleNavLinkClick(navLinkName) {
    setActiveNavLink(navLinkName);
  }

  return (
    <>
      <div className='header-wrap'>
        <header className='main-header-wrap'>
          <Header />
        </header>
      </div>
      {isDashboardRoute ? (
        // Dashboard routes get full control
        <Outlet />
      ) : (
        // Standard layout for other admin routes
        <main>
          <div className='nav-pages-layout-wrapper'>
            <div className='nav-pages-layout'>
              <nav className='nav-page-titles'>
                {/* <div className='nav-page-title-wrapper'>
               <NavLink
                to='myitemsandposts'
                className='nav-link'
                onClick={() => handleNavLinkClick('myitemsandposts')}>
                <MobileItemsAndPostsIcon
                  svgClass='nav-icon'
                  wrapperClass='nav-icon-wrapper'
                />
                <span className='nav-text'>My posts & watchlist</span>
              </NavLink>
            </div>
            <div className='nav-page-title-wrapper'>
              <NavLink
                to='settings'
                className='nav-link'
                onClick={() => handleNavLinkClick('settings')}>
                <MobileSettingsIcon
                  svgClass='nav-icon'
                  wrapperClass='nav-icon-wrapper'
                />
                <span className='nav-text'>Settings</span>
              </NavLink> 
            </div> */}
              </nav>
              <Outlet />
            </div>
          </div>
        </main>
      )}
    </>
  );
}
